import { SEOProps } from 'components/SEO/seo';
import { graphql, useStaticQuery } from 'gatsby';

const config = require('utils/constants/siteConfig');

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          description
          image
          siteUrl
          title
        }
      }
    }
  `);

  return data.site.siteMetadata;
};

export const useSEO = (props: SEOProps) => {
  const { title, description, keywords, url, image } = props;
  const {
    description: defaultDescription,
    siteUrl,
    title: defaultTitle,
    image: defaultImage,
  } = useSiteMetadata();

  return {
    description: description || defaultDescription || config.description,
    keywords: keywords || config.keywords,
    siteDescription:
      description || defaultDescription || config.siteDescription,
    siteTitle: title || defaultTitle || config.siteTitle,
    title: title || defaultTitle || config.title,
    url: siteUrl || url || config.siteUrl,
    userTwitter: config.userTwitter || '',
    image: image || defaultImage || config.image || '',
  };
};
